<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const units = [
  {
    unit: "Unit 1",
    title: "Khatam-un-Nabiyeen Hazrat Muhammad",
    to: "/11th/english/prose/khatam-un-nabiyeen-hazrat-muhammad/",
    focus: "character, mission, justice, Farewell Sermon",
    tags: ["Solved", "MCQs", "Revision"],
    stats: ["15 answers", "3 MCQs", "7+ revision points"],
  },
  {
    unit: "Unit 2",
    title: "Responsibility of the Youth in Nation-Building",
    to: "/11th/english/prose/responsibility-of-the-youth-in-nation-building/",
    focus: "discipline, duty, practical nation-building",
    tags: ["Solved", "MCQs", "Revision"],
    stats: ["core answers", "3 MCQs", "revision points"],
  },
  {
    unit: "Unit 4",
    title: "Team Moon",
    to: "/11th/english/prose/team-moon/",
    focus: "teamwork, hidden contributors, Mission Control",
    tags: ["Solved", "MCQs", "Textbook-backed"],
    stats: ["6 while-reading", "8 reading Qs", "3 MCQs"],
  },
  {
    unit: "Unit 5",
    title: "Impact of Global Warming on Pakistan",
    to: "/11th/english/prose/impact-of-global-warming-on-pakistan/",
    focus: "climate change, causes, effects, response",
    tags: ["Solved", "MCQs", "Revision"],
    stats: ["core answers", "3 MCQs", "revision points"],
  },
  {
    unit: "Unit 7",
    title: "What You Do is What You Are",
    to: "/11th/english/prose/what-you-do-is-what-you-are/",
    focus: "language, class, unpaid work, dignity",
    tags: ["Solved", "MCQs", "Revision"],
    stats: ["core answers", "3 MCQs", "revision points"],
  },
  {
    unit: "Unit 8",
    title: "Clean Water",
    to: "/11th/english/prose/clean-water/",
    focus: "public health, water access, responsibility",
    tags: ["Solved", "MCQs", "Revision"],
    stats: ["core answers", "3 MCQs", "revision points"],
  },
  {
    unit: "Unit 10",
    title: "The Punishment of Shahpesh, the Persian, on Khipil, the Builder",
    to: "/11th/english/prose/the-punishment-of-shahpesh-the-persian-on-khipil-the-builder/",
    focus: "pride, justice, punishment, moral lesson",
    tags: ["Solved", "MCQs", "Revision"],
    stats: ["core answers", "3 MCQs", "revision points"],
  },
  {
    unit: "Unit 12",
    title: "The Impact of AI on Society, Human Relationships, and Ethics",
    to: "/11th/english/prose/the-impact-of-ai-on-society-human-relationships-and-ethics/",
    focus: "AI benefits, ethics, jobs, relationships",
    tags: ["Solved", "MCQs", "Textbook-backed"],
    stats: ["8 reading Qs", "5 MCQs", "revision points"],
  },
];

const faqs = [
  {
    question: "Which prose units are included on this page?",
    answer: "Is page par Unit 1, 2, 4, 5, 7, 8, 10 aur 12 ke prose chapters milte hain.",
  },
  {
    question: "Do prose pages only give summaries?",
    answer: "Nahi. In pages me short notes, important points, reading answers aur MCQs bhi milte hain.",
  },
  {
    question: "Which prose units are strongest textbook-backed right now?",
    answer: "Team Moon aur AI wale chapter is waqt zyada detail ke sath tayyar hain.",
  },
];

usePageSeo({
  title: "11th Class English Prose",
  description: "11th class English prose units ke notes, questions aur deeper content ke liye cluster page.",
  keywords: "11th class english prose, first year prose notes",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: units.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: `${item.unit}: ${item.title}`,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Prose", item: "/11th/english/prose/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="11th Class English"
      title="Prose"
      description="Yahan 11th class English ke prose chapters ek jagah milte hain. Har chapter se aap notes, important points, short answers aur MCQs tak ja sakte hain."
    />

    <EnglishSection
      title="Prose Chapters"
      description="Apna chapter select karein aur us ki tayari shuru karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="unit in units"
          :key="unit.to"
          :title="`${unit.unit}: ${unit.title}`"
          :description="`Is chapter me ${unit.focus} par khas tawajjuh di gayi hai. Aap ko ${unit.stats.join(', ')} mil jayenge.`"
          :to="unit.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Prose chapters ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
